import styled from "styled-components";
import { ListItem } from "@mui/material";

interface ContainerPicturesProps {
  isDocumentation: boolean;
}

export const ContainerPictures = styled.div<ContainerPicturesProps>`
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: ${(props) =>
    props.isDocumentation
      ? "80vh"
      : "auto"}; /* altura fixa se for documentação */
  overflow: ${(props) =>
    props.isDocumentation
      ? "scroll"
      : "visible"}; /* scroll se for documentação */
  margin: 25px 0;
  padding: 0 50px;

  a {
    color: #000;
  }
`;

export const BoxImage = styled.div`
  width: 100%;

  div {
    width: 100% !important;
  }

  .catimg {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    cursor: zoom-in;
  }
`;

export const StyledListItem = styled(ListItem)`
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #eee;

  .MuiListItemText-primary {
    font-weight: 500;
  }

  .MuiListItemText-secondary {
    font-size: 0.85rem;
    color: #666;
  }
`;

export const BoxButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
`;

export const BoxTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
`;

export const PDFContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 570px;
  gap: 16px;
  padding: 8px;
`;
